import { toKebabCase as r } from "../utils/naming.js";
class p {
  parsers = /* @__PURE__ */ new Map();
  componentDefaults = {};
  componentShorthands = {};
  componentEnums = {};
  validations = [];
  skipProperties = {};
  adapters = {};
  register(t) {
    if (t.parsers)
      for (const [s, n] of Object.entries(t.parsers)) {
        const e = this.parsers.get(s) || [];
        e.push(n), this.parsers.set(s, e);
      }
    if (t.defaults)
      for (const [s, n] of Object.entries(t.defaults)) {
        const e = r(s);
        this.componentDefaults[e] || (this.componentDefaults[e] = {}), Object.assign(this.componentDefaults[e], n);
      }
    if (t.shorthands)
      for (const [s, n] of Object.entries(
        t.shorthands
      )) {
        const e = r(s);
        this.componentShorthands[e] || (this.componentShorthands[e] = {}), Object.assign(this.componentShorthands[e], n);
      }
    if (t.enums)
      for (const [s, n] of Object.entries(t.enums)) {
        const e = r(s);
        this.componentEnums[e] || (this.componentEnums[e] = {}), Object.assign(this.componentEnums[e], n);
      }
    if (t.validations && this.validations.push(...t.validations), t.skip)
      for (const [s, n] of Object.entries(t.skip)) {
        const e = r(s);
        this.skipProperties[e] || (this.skipProperties[e] = /* @__PURE__ */ new Set());
        for (const o of n)
          this.skipProperties[e].add(o);
      }
    if (t.adapters)
      for (const [s, n] of Object.entries(
        t.adapters
      )) {
        const e = r(s);
        this.adapters[e] || (this.adapters[e] = {}), Object.assign(this.adapters[e], n);
      }
  }
  getParser(t) {
    const s = this.parsers.get(t);
    if (!(!s || s.length === 0))
      return s.length === 1 ? s[0] : (n) => {
        for (const e of s)
          e(n);
      };
  }
  getDefaults(t) {
    return this.componentDefaults[t] || {};
  }
  getShorthands(t) {
    return this.componentShorthands[t] || {};
  }
  getAllShorthands() {
    return this.componentShorthands;
  }
  getEnums(t) {
    return this.componentEnums[t] || {};
  }
  getValidations() {
    return this.validations;
  }
  shouldSkip(t, s) {
    const n = this.skipProperties[t];
    return n ? n.has(s) : !1;
  }
  getAdapter(t, s) {
    return this.adapters[t]?.[s];
  }
  getAdapterProperties(t) {
    const s = this.adapters[t];
    return s ? Object.keys(s) : [];
  }
}
export {
  p as ConfigRegistry
};
//# sourceMappingURL=config.js.map
